export default __webpack_public_path__ + "static/media/osrcg05_2.ec441189.png";